import { PAGE_TYPES } from '../shared/utils/analytics/constants';

export const microPrefix = 'nol-portal-loyalty';

export function getPageType(slug) {
  if (slug === '/mis-puntos/' || slug === '/mis-puntos/e-store/') return PAGE_TYPES.GENERIC;

  return PAGE_TYPES.GENERIC;
}
